import React from "react";
import { motion } from "framer-motion";

const RaindropMotionFadeUp = ({
  id = undefined,
  className = "",
  delay = 0.2,
  duration = 1,
  isAnimationEnabled = true,
  children,
}) => {
  if (!isAnimationEnabled) {
    return (
      <div id={id} className={`flex items-center justify-center ${className}`}>
        {children}
      </div>
    );
  }
  return (
    <motion.div
      id={id}
      initial={{ opacity: 0, translateY: 20 }}
      transition={{
        duration: duration,
        type: "spring",
        bounce: 0.5,
        delay: delay,
      }}
      animate={{ opacity: 1, translateY: 0 }}
      className={`${className} flex w-full items-center justify-center `}
    >
      {children}
    </motion.div>
  );
};

export default RaindropMotionFadeUp;
